<!--用户 或 我的/粉丝 人列表 界面类似-->
<template>
  <div class="user-care-page">
    <div class="cargroup-list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error"
                error-text="请求失败，点击重新加载">
        <div class="list-item" v-for="(item, index) in list" :key="index">
          <div class="list-item-info">
            <div class="userpic">
              <van-image class="user-decoration" v-if="item.userDecoration" :src="item.userDecoration" round fit="cover"/>
              <van-image class="avatar" fit="cover" round :src="item.picUrl?item.picUrl:require('../assets/default_avatar.png')" @click="goUser(item.fansUserId)"/>
            </div>
            <div class="right">
              <div class="name" @click="goUser(item.fansUserId)">{{item.userName}}</div>
              <!--登录人与 粉丝人 的关注关系:0/互相关注 1/否  3未关注 4表粉丝是我本人不显示按钮-->
              <div v-if="loginerId!=item.fansUserId">
              <div class="care" v-if="item.mutuallyClose==1" @click="setCare(item.fansUserId, 1, index, 1)">已关注</div>
              <div class="care" v-else-if="item.mutuallyClose==3" @click="setCare(item.fansUserId, 0, index, 3)">关注</div>
              <div class="care" v-else-if="item.mutuallyClose==4"></div>
              <div class="care" v-else @click="setCare(item.fansUserId, 1, index, 0)">互相关注</div><!--参数0-->
              </div>
            </div>
          </div>
          <div class="list-item-line"></div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
  import { getFansList, careUser, getOneUserInfo } from '../api/user'
  export default {
    name: 'userfans',
    components: {},
    props: {},
    data () {
      return {
        uid: this.$route.params.id,
        token: '',
        list: [],
        isLoginer: false, // 登录者非本人, 则修改页面标题文字
        loginerId: '',
        userName: '', // 非登录者 用户的name
        curPage: 1, // 默认请求第一页数据
        loading: false, // 上滑滚动
        finished: false, // 上滑滚动
        error: false, // 控制列表加载失败的提示状态
      }
    },
    computed: {},
    watch: {
    },
    created () {
      this.loginerId = this.$utils.getLocal('userInfo') ? this.$utils.getLocal('userInfo').id : ''
      if (this.$utils.getLocal('userInfo') && (this.$utils.getLocal('userInfo').id == this.$route.params.id)) {
        this.isLoginer = true// 是本人列表
      } else {
        this.getUserName()// 查询用户昵称
      }
    },
    mounted () {},
    methods: {
      // 点击navbar返回
      onClickLeft() {
        this.$router.back(-1)
      },
      goUser(uid) {
        let baurl = this.$utils.getUrl('/user/2/' + uid);
        let titleStr = this.loginerId == uid ? '个人中心' : '  '
        if (window.mobileAgent.isRunOnApp()) {
          window.mobileAgent.openNewWindow(baurl, titleStr)
        } else {
          this.$router.push({ path: '/user/2/' + uid }) // 传参 问答分类cid
        }
      },
      // 查询user姓名
      async getUserName () {
        try {
          const { data } = await getOneUserInfo({
            userId: this.$route.params.id, // 非登录人的用户id
            token: this.$utils.getLocal('userInfo') ? this.$utils.getLocal('userInfo').token : ''
          });
          if (data.resultCode == 200) {
            this.userName = data.data[0].name
          } else if (data.resultCode == 509) {
            this.$toast.fail('请登录App后操作')
            window.mobileAgent.logoutToTrunk()
          } else {
            this.$toast.fail(data.message)
          }
        } catch (err) {
          console.log(err)
          this.$toast.fail('获取数据失败')
        }
      },
      // 提供给监听钩子用的:作用：点击取消关注/取消收藏 页面列表数据同步消失
      // 关注的list
      async onLoad () {
        try {
          const { data } = await getFansList({
            size: 10,
            current: this.curPage,
            userId: this.$route.params.id,
            token: this.$utils.getLocal('userInfo') ? this.$utils.getLocal('userInfo').token : '',
            operationId: this.$utils.getLocal('userInfo') ? this.$utils.getLocal('userInfo').id : '' // 登录人的id
          });
          if (data.resultCode == 200) {
            this.loading = false;// 3.本次请求加载完成后 要把加载状态设置为结束,false后 才能触发下一次 加载更多
            // 4.判断数据全部加载完成
            if (data.data.length) {
              // 说明 本次请求 还有数据，则 继续出现 加载更多!!!! 更新 下次请求的 页码值
              this.curPage += 1 // 修改当前的页码为 下一页的数值
              // 循环判断当前list图像框
              let userDecoration = process.env.VUE_APP_BASE_IMG_URL
              for (let i = 0; i < data.data.length; i++) {
                // 判断对应的用户挂件图像框:无需登录就先判断成就图像框在不在
                let imgUrl = userDecoration + data.data[i].fansUserId + '.png'
                let res = await this.$utils.imgExists(imgUrl);// 异步变同步请求
                if (res) {
                  data.data[i].userDecoration = imgUrl
                } else {
                  data.data[i].userDecoration = ''
                }
                data.data[i].picUrl = this.$utils.transhttps(data.data[i].picUrl)
              }
              this.list.push(...data.data)
            } else {
              this.finished = true;// 如果没有数据了，就设为true  不再触发加载更多
            }
          } else {
            this.error = true // 控制显示错误提示信息,点击提示语后会自动发新的网络请求
            this.loading = false// 请求失败了,与此同时 也要关闭 loading加载
            this.$toast.fail(data.message)
          }
        } catch (err) {
          console.log(err)
          this.$toast.fail('获取数据失败')
        }
      },
      // 针对xx的粉丝列表： 我(登录人)来操作关注,主要操作就是取消关注，然后在页面list中删除该数据
      async setCare (uid, setVal, index, orCareVal = '') {
        if (this.$utils.getLocal('userInfo') && this.$utils.getLocal('userInfo').id) {
          try {
            // 操作关注：为取消关注  传参：userId  token  focusUserId type=0添加关注 1取消关注
            const { data } = await careUser({
              userId: this.$utils.getLocal('userInfo').id, // 登录人id
              token: this.$utils.getLocal('userInfo') ? this.$utils.getLocal('userInfo').token : '',
              focusUserId: uid,
              type: setVal // 入参说明:1表取消
            });
            if (data.resultCode == 509) {
              this.$toast.fail('请登录App后操作')
              this.$utils.clearUserInfo('userInfo')
              window.mobileAgent.logoutToTrunk()
            }
            if (data.resultCode == 200) {
              // 针对url传参uid=缓存的uid 说明要操作：登录人我的列表，此时才需要隐藏，否则不要隐藏
              if (this.$route.params.id == this.$utils.getLocal('userInfo').id) {
                if (orCareVal < 2) {
                  this.list.splice(index, 1)// splice针对数组有效,从数组中删掉item
                }
              }
              // setVal==0 要添加关注   1取消关注
              // 0/互相关注 1/否  3未关注 4表粉丝是我本人不显示按钮
              // console.log('index==' + index)
              // console.log('setVal==' + setVal)
              // console.log(this.list)
              let change = this.list[index]
              // console.log('您要修改的item的mutuallyClose==' + change)
              // console.log('如果你要修改的状态=互相关注，则：你取消关注了，此人仍然会在你的列表中，而且显示【关注】按钮，你可以继续关注它')
              // if (setVal) {
              //   // 设状态为 【关注】
              //   change.mutuallyClose = 3
              //   this.$set(this.list, index, change) // 局部更新item.isFocus 下某个参数值
              // } else {
              //   // 设状态为【已关注】
              //   console.log(change)
              //   change.mutuallyClose = 1
              //   this.$set(this.list, index, change) // 局部更新item.isFocus 下某个参数值
              // }
              if (orCareVal < 2) {
                  change.mutuallyClose = 3
                  this.$set(this.list, index, change) // 局部更新item.isFocus 下某个参数值
              }
              if (orCareVal == 3) {
                  change.mutuallyClose = 1
                  this.$set(this.list, index, change) // 局部更新item.isFocus 下某个参数值
              }
              this.$toast.success('操作成功')
            } else {
              this.$toast.fail(data.message)
            }
          } catch (err) {
            console.log(err)
            // this.$toast.fail('操作失败')
          }
        } else {
          this.$toast.fail('请登录App后操作')
          window.mobileAgent.logoutToTrunk()
        }
      },
    }
  }
</script>

<style scoped lang="less">
  .user-care-page{
    /*这句话的目的：头部留白 别的代码不用改*/
    /deep/ .van-nav-bar{
      border-bottom: 2px solid #FFFFFF;
      box-shadow: 0px 4px 6px 0px rgba(195, 204, 225, 0.51);
      padding-top: 68px;
      z-index: 20;
    }
    /deep/  .van-nav-bar__placeholder{
      .van-hairline--bottom{
        border: 0px;
      }
    }
    /*顶部navbar 名称*/
    .navbar-title{
      width: 68px;
      height: 48px;
      font-size: 34px;
      font-family: 'PingFangSC-Medium, PingFang SC';
      font-weight: 500;
      color: #333333;
      line-height: 48px;
      text-align: center;
      text-shadow: 0px 4px 6px rgba(195, 204, 225, 0.51);
    }
    .cargroup-list{
      display: flex;
      flex-direction: column;
      margin-top: 20px;
      margin-left: 30px;
      //单个 item 最外边大样式
      .list-item{
        margin-top: 15px;
        display: flex;
        flex-direction: column;
        /*里面item样式 上部分*/
        .list-item-info{
          display: flex;
          flex-direction: row;
          align-items: center;
          align-content: center;
          .userpic {
            position: relative; /*大div中要包含悬浮图像框，所以作为根节点*/
            /*每个item用户图像*/
            .avatar {
              width: 90px;
              height: 90px;
              margin-right: 20px;
            }
            /*悬浮图像框*/
            .user-decoration{
              width: 110px;
              height: 110px;
              position: absolute;/*将悬浮的图像设置绝对定位,然后通过top，bottom，left，right来修改悬浮位置,然后用 z-index 设置显示层级,高于底部图像*/
              top: -10px;
              left: -10px;
              z-index: 3;/*超过10就不好了*/
            }
          }
          .right{
            width: 580px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            align-content: center;
            .name{
              height: 42px;
              font-size: 30px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #2D3448;
              line-height: 42px;
            }
            .care{
              width: 160px;
              height: 62px;
              font-size: 28px;
              font-weight: 500;
              color: #2365FF;
              background: rgba(35, 101, 255, 0.07);
              border-radius: 31px;
              /*按钮 文字居中begin*/
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              align-content: center;
              /*按钮 文字居中end*/
            }
          }
        }
        /*item下部分*/
        .list-item-line{
          margin-left: 100px;
          margin-top: 15px;
          width: 580px;
          height: 2px;
          background: #E8E8E8;
        }
      }
    }
  }
</style>
